import { POPUP_TYPES } from '@/features/Popup/constants.ts';

export enum DISPLAY_PRIORITY {
  REALITY_CHECK_POPUP = 0,
  EXIT_POPUP = 1,
  EXIT_POPUP_RECENTLY_PLAYED = 2,
  GEOLOCATION_REFRESH = 3,
  JACKPOT_WIN = 4,
  IN_GAME_MERCH = 5,
  SWJ_POPUP = 6,
  PROVIDER_ERROR = 7,
  unknown = 8,
}

type DisplayPriorityType = keyof typeof POPUP_TYPES;

const getPriority = (type: string): number => {
  const p = DISPLAY_PRIORITY[type];
  return typeof p === 'number' ? p : DISPLAY_PRIORITY.unknown;
};

const queueAssigner = (
  prevQueue: Array<{ type: DisplayPriorityType; popup: () => void }>,
  message: { type: DisplayPriorityType; popup: () => void },
) => {
  if (prevQueue.length === 0) {
    return [message];
  }

  if (
    message.type === POPUP_TYPES.SWJ &&
    prevQueue.some((item) => item.type === POPUP_TYPES.SWJ)
  ) {
    return prevQueue;
  }

  const queueWithoutExisting =
    message.type === POPUP_TYPES.IN_GAME_MERCH
      ? prevQueue.filter((item) => item.type !== POPUP_TYPES.IN_GAME_MERCH)
      : prevQueue;

  return [...queueWithoutExisting, message].sort(
    (a, b) => getPriority(a.type) - getPriority(b.type),
  );
};

export { queueAssigner };
